module.exports = __webpack_public_path__ + "img/11.e0b672d9.png";